import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '../queryKeys';
import { getMembers } from 'services/api/AccessManagerAPI';

// The people the caller may see in a company, and what they may hand out.
// accountId: the company a super admin manages; omitted, the caller's own.
// enabled: false holds the request back (a super admin who has not picked a
// company yet — without one the answer would be their own company's people).
export const useGetMembers = (accountId?: string, enabled = true) => {
    const { data, isLoading, ...rest } = useQuery({
        queryKey: queryKeys.members(accountId),
        queryFn: () => getMembers(accountId),
        enabled,
    });

    return { membersData: data, isMembersLoading: isLoading, ...rest };
};
